import api from './api';

export const inscriptionService = {
  // Soumettre une inscription
  submit: async (data) => {
    try {
      const response = await api.post('/inscriptions', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la soumission de l\'inscription:', error);
      throw error;
    }
  },

  // Récupérer toutes les inscriptions (admin)
  getAll: async (page = 1) => {
    try {
      const response = await api.get(`/admin/inscriptions?page=${page}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des inscriptions:', error);
      throw error;
    }
  },

  // Récupérer une inscription par ID (admin)
  getById: async (id) => {
    try {
      const response = await api.get(`/admin/inscriptions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'inscription:', error);
      throw error;
    }
  },

  // Mettre à jour le statut d'une inscription (admin)
  updateStatut: async (id, statut) => {
    try {
      const response = await api.put(`/admin/inscriptions/${id}/statut`, { statut });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut:', error);
      throw error;
    }
  },

  // Supprimer une inscription (admin)
  delete: async (id) => {
    try {
      const response = await api.delete(`/admin/inscriptions/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'inscription:', error);
      throw error;
    }
  }
};
